UABatchEditAccountsCtrl.$inject = ['users', 'adminApi', 'contentProfiles']

export default function UABatchEditAccountsCtrl(users, adminApi, contentProfileStore) {
  this.accountFieldsToUpdate = {}
  this.users = users

  this.showError = false
  this.errorMessage = ''
  this.updateSuccess = false
  this.numUpdated = null
  this.saving = false
  this.contentProfiles = []
  this.idpList = []
  this.ssoConfig = { option: 'assign' }

  this.clearSsoProviders = function() {
    this.accountFieldsToUpdate.sso_provider_ids = []
  }

  this.$onInit = function() {
    contentProfileStore.getContentProfiles().then(profiles => {
      this.contentProfiles = profiles
    })
    adminApi.getIdentityProvidersList().then(idps => {
      this.idpList = idps
    })
  }

  this.save = function() {
    if (!confirm('Are you sure you want to update these fields for ' + users.length + ' users?')) {
      return
    }
    this.saving = true
    let userUuids = users.map(user => user.uuid)
    if (this.accountFieldsToUpdate['enforce_sso']) {
      if (this.accountFieldsToUpdate['enforce_sso'] === 'true') {
        this.accountFieldsToUpdate['enforce_sso'] = true
      } else if (this.accountFieldsToUpdate['enforce_sso'] === 'false') {
        this.accountFieldsToUpdate['enforce_sso'] = false
      }
    }

    adminApi
      .batchUpdateAccounts(userUuids, this.accountFieldsToUpdate)
      .then(
        function(resp) {
          this.showError = false
          this.updateSuccess = true
          this.numUpdated = resp
        }.bind(this),
        function(resp) {
          this.showError = true
          this.errorMessage = resp
        }.bind(this)
      )
      .finally(
        function() {
          this.saving = false
        }.bind(this)
      )
  }
}
